import { Component, OnInit, Input, ViewChild, AfterViewInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { sortingDataAccessor } from '@shared/utils/angular-material-tools';
import { Inventory } from '@data/models/inventory.model';
import { FilterService } from '@shared/services/filter.service';
import { MatInput } from '@angular/material/input';

const DEFAULT_LIST_SIZE = 10;

@Component({
    selector: 'syn-inventories-table',
    templateUrl: './inventories-table.component.html',
    styleUrls: ['./inventories-table.component.scss']
})
export class InventoriesTableComponent implements OnInit, AfterViewInit, OnChanges {

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input() inventories: Inventory[] = [];
    @Input() loading: boolean;
    @Input() message: string;
    @Input() noDataMessage = 'Aucun inventaire.';
    @Input() pageSize: Number;
    @Input() pageSizeOptions: Number[] = [5, 10, 25, 100];
    @Input() totalSize: number;
    @Input() clientSidePagination = false;

    @Output() pageChangeEvent: EventEmitter<number> = new EventEmitter();
    @Output() searchEvent: EventEmitter<string> = new EventEmitter();
    @Output() toggleUnprovisionedEvent: EventEmitter<boolean> = new EventEmitter();

    public dataSource: MatTableDataSource<Inventory>;
    public displayedColumns: String[] = ['name', 'status', 'environment', 'type/subtype', 'tags'];
    public showPaginator = false;
    public pageIndex = 0;
    public displayUnprovisionnedInventories = false;

    constructor(private filterService: FilterService) {
        this.dataSource = new MatTableDataSource<Inventory>(
            this.clientSidePagination ? this.filterService.filterInventoriesByStatus(this.inventories) : this.inventories
        );
    }

    ngOnInit() {
        this.pageSize = this.pageSizeOptions.length === 0 ? 0 : DEFAULT_LIST_SIZE;
        this.showPaginator = (this.totalSize > DEFAULT_LIST_SIZE) || (this.inventories.length > DEFAULT_LIST_SIZE);
    }

    ngAfterViewInit(): void {
        this.dataSource.sortingDataAccessor = sortingDataAccessor;
        this.dataSource.sort = this.sort;

        // Only set paginator for client-side pagination
        if (this.clientSidePagination) {
            this.dataSource.paginator = this.paginator;
        }

        this.paginator.page.subscribe((event: PageEvent) => this.onPageChange(event));
    }

    ngOnChanges() {
        if (this.inventories && this.dataSource) {
            if (this.clientSidePagination) {
                this.dataSource.data = this.displayUnprovisionnedInventories ? this.inventories :
                    this.filterService.filterInventoriesByStatus(this.inventories);
            } else {
                this.dataSource.data = this.inventories;
            }
        }
    }

    onToggleChange(isChecked: boolean) {
        if (this.clientSidePagination) {
            this.displayUnprovisionnedInventories = isChecked;
            this.dataSource.data = isChecked ? this.inventories : this.filterService.filterInventoriesByStatus(this.inventories);
            return;
        }

        this.toggleUnprovisionedEvent.next(isChecked);
    }

    onPageChange(event: PageEvent): void {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;

        this.pageChangeEvent.emit(this.pageIndex);
    }

    applyFilter(term: string, input: MatInput): void {
        if (this.clientSidePagination) {
            this.dataSource.filter = term.trim().toLowerCase();

            if (input) {
                input.value = term;
            }
            return;
        }

        this.searchEvent.emit(term);
    }
}
